import type { ExportPeriodParams } from '@acs/shared';
import { downloadBlob, requestBlob } from '@/api';

function toExportSearchParams(params: ExportPeriodParams = {}) {
  const searchParams = new URLSearchParams();

  if (params.period) searchParams.set('period', params.period);
  if (params.year) searchParams.set('year', params.year);
  if (params.quarter) searchParams.set('quarter', params.quarter);
  if (params.from) searchParams.set('from', params.from);
  if (params.to) searchParams.set('to', params.to);

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
}

export const exportApiClient = {
  exportMyData: async (params?: ExportPeriodParams) =>
    downloadBlob(
      await requestBlob(`/export-my-data${toExportSearchParams(params)}`, { method: 'GET' }),
      'my_data.xlsx'
    ),
  exportAllData: async (params?: ExportPeriodParams) =>
    downloadBlob(
      await requestBlob(`/export-all-data${toExportSearchParams(params)}`, { method: 'GET' }),
      'all_data.xlsx'
    )
};
